export const ValueItem = ({
  name,
  onDelete,
  onEdit,
}: {
  name: string;
  onDelete: () => void;
  onEdit: () => void;
}) => (
  <div className="flex gap-[1px] w-full">
    <div className="grid content-center w-full bg-grayBg px-3 py-0.5 text-sm">
      {name}
    </div>
    <button
      onClick={(e) => {
        e.preventDefault();
        onEdit();
      }}
      className="bg-grayBg px-2 py-0.5 text-white hover:bg-darkGrayBg"
    >
      <i className="icon-edit text-xs" />
    </button>
    <button
      onClick={(e) => {
        e.preventDefault();
        onDelete();
      }}
      className="bg-grayBg px-2 py-0.5 text-white hover:bg-darkGrayBg"
    >
      <i className="icon-close text-xs" />
    </button>
  </div>
);
